import { useEffect, useState } from "react";

import { getInquiries, getSuggests } from "shared/api/InquirySuggestApi";
import { getNotices } from "shared/api/NoticeApi";

/**
 * 홈 대시보드에 필요한 공지, 건의, 문의 정보를 불러오는 훅
 */
export const useHomeDashboardData = () => {
  const [inquiries, setInquiries] = useState([]);
  const [suggests, setSuggests] = useState([]);
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    getInquiries()
      .then(setInquiries)
      .catch(() => setInquiries([]));
    getSuggests()
      .then(setSuggests)
      .catch(() => setSuggests([]));
    getNotices()
      .then(setNotices)
      .catch(() => setNotices([]));
  }, []);

  return {
    inquiries,
    suggests,
    notices,
  };
};
